<template>
	<div class="home">
		<Encabezado></Encabezado>

		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div id="itemList">
					<div class="itemList-controls">
						<div class="controls controls-left">
                            <router-link class="btn GeneralLeave-back btnBack" to="/anticipos">
							    <font-awesome-icon icon="fa-solid fa-circle-chevron-left" /> Atrás
							</router-link>
                        </div>
						<div class="title">
							<h3>Anticipos</h3>
						</div>
					</div>
                    <div class="itemList-header">
                        <h1>Nueva Solicitud de Anticipo</h1>
                    </div>
                    <div class="item-Form">
                        <div class="panel-body">
                            <form 
                                class="form-horizontal" 
                                id="formNuevoAnticipo"
                                @submit.prevent="enviarDatosFormulario"
                            >
                                <div class="form-group">
                                    <div class="col-md-12 col-xs-12">
                                        <b>Indique 0€ en <u>Importe</u>, si desea solicitar el importe máximo.</b>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-md-6 col-xs-12">
                                        <label for="Title">Título </label>
                                        <input v-model="titulo" ref="titulo" placeholder="Título" class="form-control" data-val="true" id="Title" name="Title" type="text" value="" required>
                                    </div>
                                </div>
                                <hr />
                                <div class="form-group">
                                    <div class="col-md-6 col-xs-12">
                                        <label for="Amount">Importe (€)</label>
                                        <input v-model="importe" class="form-control number" data-val="true" id="importe" name="importe" type="number" value="0" min="0" max="10000" required>
                                    </div>
                                    <div class="col-md-6 col-xs-12">
                                        <label for="PaymentMethod">Devolución</label>
                                        <select v-model="devolucion" class="form-control" id="PaymentMethod" name="PaymentMethod">
                                            <option>Paga normal</option>
                                            <option>Paga extra</option>
                                            <option>Préstamo</option>
                                        </select>
                                        <input id="PaymentMethod" name="PaymentMethod" type="hidden" value="">
                                    </div>
                                </div>
                                <hr />
                                <div class="form-group">
                                    <div class="col-md-12">
                                        <label for="Observaciones">Observaciones</label>
                                        <textarea v-model="observaciones" class="form-control" cols="20" id="observaciones" name="observaciones" rows="5"></textarea>                                    
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-md-12">
                                        <input :disabled="enviandoDatosFormulario" type="submit" class="btn btn-lg btn-primary" id="btnSave" :value="textoBtnEnvio">
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
    // @ is an alias to /src
    import Encabezado from "@/components/Encabezado.vue";
    import Footer from "@/components/Footer.vue";
    import router from "@/router";
    
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/es';


    export default {
        name: "NuevoAnticipo",
		components: {
            Encabezado,
            Footer
        },
		data() { 
			return{
                titulo: "",
                importe: 0,
                devolucion: "Paga normal",
                observaciones: null
            }
		},
		mounted() {
            this.$store.commit('establecerEstadoEnviandoDatosFormulario', false);
            this.$store.commit('establecerGuardadoOK', false);

			document.body.classList.remove("bg-login");
			document.body.classList.remove("login-page");
            this.$refs.titulo.focus();
		},
        watch:{
            guardadoOK: function(newValue){
                if (newValue){
                    this.$toast.open({
                        message: "Los datos se han guardado correctamente",
                        type: "success",
                        duration: 500,
                        dismissible: false,
                        position: "top",
                        onDismiss: this.redireccionListaAnticipos
                    });
                }
            }
        },
		computed:{
            guardadoOK: function(){
                return this.$store.state.guardadoOK;
            },
            textoBtnEnvio: function() {
                if (this.enviandoDatosFormulario) return 'Enviando...';
                return 'Enviar';
            },
            enviandoDatosFormulario: function(){
                return this.$store.state.enviandoDatosFormulario; 
            }
		},
        methods:{
            enviarDatosFormulario: function(){
                this.$store.dispatch('enviarDatosNuevoAnticipo', 
                    {
                        titulo: this.titulo,
                        importe: this.importe.toString(),
                        devolucion: this.devolucion,
                        observaciones: this.observaciones
                    }
                );
            },
            redireccionListaAnticipos: function(){
                router.replace('/anticipos');
                this.$store.commit('establecerGuardadoOK', false);
            }
        }
    };
</script>

<style>
    @import "../assets/styles/home.css";
</style>
